const pendingCancels = new Set<() => void>();

/**
 * Отменяет все pending deferred notify микротаски.
 * Вызывается из cleanupFlows() для очистки между тестами.
 */
export function cleanupDeferredNotifies() {
    for (const cancel of pendingCancels) {
        cancel();
    }
    pendingCancels.clear();
}

/**
 * Откладывает вызов notify через микротаск с дедупликацией.
 * Множественные вызовы в одном синхронном потоке схлопываются в один отложенный вызов.
 *
 * @returns [deferred, cancel] — отложенный notify и функция отмены pending микротаска
 */
export function createDeferredNotify(notify: () => void): [deferred: () => void, cancel: () => void] {
    let pending = false;
    let cancelled = false;

    function cancel() {
        if (pending) {
            cancelled = true;
            pending = false;
            pendingCancels.delete(cancel);
        }
    }

    function deferred() {
        if (pending) return;
        pending = true;
        cancelled = false;
        pendingCancels.add(cancel);
        queueMicrotask(() => {
            pending = false;
            if (cancelled) {
                cancelled = false;
                return;
            }
            pendingCancels.delete(cancel);
            notify();
        });
    }

    return [deferred, cancel];
}
